import { Component, OnInit, Input } from '@angular/core'
import { FormControl } from '@angular/forms'
import * as lodash from 'lodash'
import { getCurrenciesWithFlagIcon } from '../../constants'
import { Destroyable } from '../../rx-operators'

@Component({
  selector: 'app-currency-select',
  templateUrl: './currency-select.component.html',
  styleUrls: ['./currency-select.component.scss'],
})
export class CurrencySelectComponent extends Destroyable implements OnInit {
  currencies = getCurrenciesWithFlagIcon()

  @Input() ctrl: FormControl

  @Input() inline = false
  @Input() compareWith = (o1: any, o2: any) => (lodash.isObjectLike(o1) ? o1?.code === o2?.code : o1 === o2)
  @Input() bindValue = (c: any) => c

  @Input() label = $localize`Currency`

  ngOnInit(): void {}
}
